"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheM4SelfBalancingExperience() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="222802" id="repüljön-a-legjobb-áron" className="dark bg-background py-20 md:py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="bg-card rounded-2xl md:rounded-3xl p-8 md:p-16 lg:p-20 flex flex-col md:flex-row items-center gap-12 lg:gap-20 relative shadow-3xl border border-border/50">
          
          {}
          <div ref={textRef} className={`w-full md:w-[45%] flex flex-col gap-6 lg:gap-8 z-10 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tighter">
              Repüljön a legjobb áron
            </h2>
            <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed max-w-md">
              Fedezze fel a világot prémium légitársaságokkal. Intelligens keresőmotorunkkal pillanatok alatt megtalálja a legkedvezőbb ajánlatokat.
            </p>
            <div className="flex flex-wrap items-center gap-4 pt-2">
              <Button asChild size="lg" className="rounded-full px-8 bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg transition-transform hover:scale-105">
                <Link to="#">Keresés indítása</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full px-8 border-primary text-primary hover:bg-accent hover:text-accent-foreground transition-all">
                <Link to="#">Ajánlatkérés</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imgRef} className={`w-full md:w-[55%] relative flex justify-center md:justify-end transition-all duration-1000 delay-200 ease-out ${isImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/luxury_flight_booking_interface.png" alt="Repülőjegy foglalási felület" className="w-full max-w-[500px] md:max-w-none md:w-[115%] lg:w-[125%] h-auto object-contain drop-shadow-4xl md:-mr-12 lg:-mr-24 scale-105 md:scale-110 origin-center md:origin-right" />
          </div>
          
        </div>
      </div>
    </section>;
}